export const FORMATIONS = {
  "442": {
    rows: {
      keeper: ["GK"],
      row1: ["LB", "LCB", "RCB", "RB"],
      row2: ["LM", "LCM", "RCM", "RM"],
      row3: ["LS", "RS"]
    }
  },

  "433": {
    rows: {
      keeper: ["GK"],
      row1: ["LB", "LCB", "RCB", "RB"],
      row2: ["LCM", "CM", "RCM"],
      row3: ["LW", "ST", "RW"]
    }
  },

  // ✅ MATCHES mapping exactly
  "4231": {
    rows: {
      keeper: ["GK"],
      row1: ["LB", "LCB", "RCB", "RB"],
      row2: ["LDM", "RDM"],
      row3: ["LW", "CAM", "RW"],
      row4: ["ST"]
    }
  },

  "343": {
    rows: {
      keeper: ["GK"],
      row1: ["LCB", "CB", "RCB"],
      row2: ["LM", "LCM", "RCM", "RM"],
      row3: ["LW", "ST", "RW"]
    }
  },

  "3421": {
    rows: {
      keeper: ["GK"],
      row1: ["LCB", "CB", "RCB"],
      row2: ["LWB", "LCM", "RCM", "RWB"],
      row3: ["LAM", "RAM"],
      row4: ["ST"]
    }
  },

  "352": {
    rows: {
      keeper: ["GK"],
      row1: ["LCB", "CB", "RCB"],
      row2: ["LWB", "LCM", "CM", "RCM", "RWB"],
      row3: ["LS", "RS"]
    }
  }
};
